import { render, staticRenderFns } from "./PeopleInHub.vue?vue&type=template&id=7a89c16a"
import script from "./PeopleInHub.vue?vue&type=script&lang=js"
export * from "./PeopleInHub.vue?vue&type=script&lang=js"
import style0 from "./PeopleInHub.vue?vue&type=style&index=0&id=7a89c16a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports